import { FC } from 'react';
import { BlockResize } from 'components/BlockResize';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { Field } from 'ui/Field';
import styles from './MainDocument.module.scss';

export const MainDocument: FC = () => {
  const { infoEmployeds, openBlock } = useSelector(
    (state: RootState) => state.employedsDetailSlice,
  );
  const { nationality } = infoEmployeds || {};

  return (
    <BlockResize open={openBlock} title='Основной документ'>
      <div className={styles.root} id='mainDocAnchor'>
        <div className={styles.row}>
          <Field
            style={{ width: '100%' }}
            placeholder='Гражданство'
            title={nationality}
          />
          <Field style={{ width: '100%' }} placeholder='Документ' title={'Паспорт'} />
        </div>

        <div className={styles.row} style={{ position: 'relative' }}>
          <div className={styles.series}>
            <Field
              style={{ width: '128px' }}
              placeholder='Серия'
              title={infoEmployeds.passport_s}
            />
          </div>

          <div className={styles.number}>
            <Field
              style={{ width: '190px' }}
              placeholder='Номер'
              title={infoEmployeds.passport_n}
            />
          </div>

          <div className={styles.code}>
            <Field
              style={{ width: '190px' }}
              placeholder='Код подразделения'
              title={infoEmployeds.passport_kod}
            />
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.issued}>
            <Field
              style={{ width: '330px' }}
              placeholder='Выдан'
              title={infoEmployeds.passport_kem}
            />
          </div>
          <div className={styles.datePassport}>
            <Field
              style={{ width: '190px' }}
              placeholder='Дата выдачи'
              title={infoEmployeds.passport_date}
            />
          </div>
        </div>

        <div className={styles.address}>
          <Field
            style={{ width: '100%' }}
            placeholder='Адрес прописки'
            title={infoEmployeds.address_passport}
          />
        </div>
      </div>
    </BlockResize>
  );
};
